import { PlusCircle } from '@phosphor-icons/react';

export default PlusCircle;
